import { useTranslation } from "react-i18next";
import { GoX } from "react-icons/go";
import { IFavoriteInfoType } from "../types/favorite_types";

interface FavoriteDeleteButtonProps {
  showConfirmDialog: (message: string) => void;
  favoriteInfo: IFavoriteInfoType;
  setFavoriteInfo: React.Dispatch<React.SetStateAction<IFavoriteInfoType>>;
}

export const FavoriteDeleteButton: React.FC<FavoriteDeleteButtonProps> = ({
  showConfirmDialog,
  favoriteInfo,
  setFavoriteInfo,
}) => {
  //言語切替用
  const { t } = useTranslation();

  const handleOnDeleteButton = () => {
    setFavoriteInfo(favoriteInfo);
    showConfirmDialog(t("お気に入り画面.このお気に入りを削除しますか？")); //このお気に入りを削除しますか？
  };

  return (
    <div>
      <button
        onClick={handleOnDeleteButton}
        className="absolute right-0 overflow-visible p-1"
      >
        <GoX size={"1.25rem"} />
      </button>
    </div>
  );
};
